import { type Dispatch, useEffect, useState } from 'react';
import { getLastSearchPrepackage } from '../../common/lastSearch';
import type { PrepackageSearchState } from '../../types';
import actions from '../prepackageActions';

export const usePrepackageInitialState = (
    dispatch: Dispatch<ReturnType<(typeof actions)[keyof typeof actions]>>,
    prefill?: Partial<PrepackageSearchState>,
): boolean => {
    const [ready, setReady] = useState(false);

    useEffect(() => {
        const persisted = getLastSearchPrepackage();
        dispatch(actions.allFieldsChanged({ ...persisted, ...prefill }));
        setReady(true);
    }, [dispatch, prefill]);

    return ready;
};
